import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getSeoData } from "../api/apiClient";

const SEO = ({ title, description, keywords }) => {
  const location = useLocation();
  const [dynamicSeo, setDynamicSeo] = useState(null);

  const siteDomain = "https://gatewayfinancial.com";
  const canonicalUrl = `${siteDomain}${location.pathname}`;

  useEffect(() => {
    let isMounted = true;

    const fetchSeo = async () => {
      try {
        const slug =
          location.pathname === "/" ? "home" : location.pathname.substring(1);

        const response = await getSeoData(slug);

        if (isMounted) {
          if (response?.status && response?.data) {
            setDynamicSeo(response.data);
          } else {
            setDynamicSeo(null);
          }
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
        if (isMounted) {
          setDynamicSeo(null);
        }
      }
    };

    fetchSeo();

    return () => {
      isMounted = false;
    };
  }, [location.pathname]);

  const baseTitle = "Gateway Financial Services Limited";

  const finalTitle = dynamicSeo?.meta_title || title;
  const fullTitle = finalTitle ? `${finalTitle} | ${baseTitle}` : baseTitle;

  const finalDescription =
    dynamicSeo?.meta_description ||
    description ||
    "Gateway Financial Services Limited is a dynamic financial advisory and investment solutions firm committed to helping individuals and businesses achieve their financial goals.";

  const finalKeywords =
    dynamicSeo?.meta_keywords ||
    keywords ||
    "financial advisory, investment solutions, mutual funds, equity trading, commodity trading, depository services, global investments, insurance products";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={`${siteDomain}/images/logo.png`} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={finalDescription} />
      <meta
        property="twitter:image"
        content={`${siteDomain}/images/logo.png`}
      />
    </Helmet>
  );
};

export default SEO;
